function createWhiteWithAlpha(alpha: number): string {
  return `rgba(255, 255, 255, ${alpha})`;
}

function createBlackWithAlpha(alpha: number): string {
  return `rgba(0, 0, 0, ${alpha})`;
}

// Allows us to leverage the static and readonly part - creates the values once
export abstract class Colors {
  public static readonly PAPER = '#F8F8F8';
  public static readonly PAPER_DARKER_1 = '#f1f1f1';

  public static readonly PRIMARY = 'rgb(218, 23, 23)';
  public static readonly PRIMARY_DARKER_1 = 'rgb(238,61,61)';
  public static readonly PRIMARY_DARKER_2 = 'rgb(220, 61, 61)';

  public static readonly PRIMARY_75 = 'rgba(218, 23, 23, 0.75)';
  public static readonly PRIMARY_50 = 'rgba(218, 23, 23, 0.5)';
  public static readonly PRIMARY_35 = 'rgba(218, 23, 23, 0.35)';
  public static readonly PRIMARY_25 = 'rgba(218, 23, 23, 0.25)';
  public static readonly PRIMARY_15 = 'rgba(218, 23, 23, 0.15)';
  public static readonly PRIMARY_10 = 'rgba(218, 23, 23, 0.10)';
  public static readonly PRIMARY_5 = 'rgba(218, 23, 23, 0.05)';
  public static readonly PRIMARY_3 = 'rgba(218, 23, 23, 0.03)';
  public static readonly PRIMARY_1 = 'rgba(218, 23, 23, 0.01)';

  public static readonly SECONDARY = 'rgb(16, 16, 16)';

  public static readonly PAPER_BORDER = '1px solid #e6e6e6';

  public static readonly WARN = 'orange';

  public static readonly INPUT_BACKGROUND = '#fbfbfb';

  public static readonly WHITE_100 = createWhiteWithAlpha(1);
  public static readonly WHITE_90 = createWhiteWithAlpha(0.9);
  public static readonly WHITE_80 = createWhiteWithAlpha(0.8);
  public static readonly WHITE_70 = createWhiteWithAlpha(0.7);
  public static readonly WHITE_60 = createWhiteWithAlpha(0.6);
  public static readonly WHITE_50 = createWhiteWithAlpha(0.5);
  public static readonly WHITE_40 = createWhiteWithAlpha(0.4);
  public static readonly WHITE_30 = createWhiteWithAlpha(0.3);
  public static readonly WHITE_25 = createWhiteWithAlpha(0.25);
  public static readonly WHITE_20 = createWhiteWithAlpha(0.2);
  public static readonly WHITE_15 = createWhiteWithAlpha(0.15);
  public static readonly WHITE_10 = createWhiteWithAlpha(0.1);
  public static readonly WHITE_5 = createWhiteWithAlpha(0.05);

  public static readonly BLACK_100 = createBlackWithAlpha(1);
  public static readonly BLACK_90 = createBlackWithAlpha(0.9);
  public static readonly BLACK_80 = createBlackWithAlpha(0.8);
  public static readonly BLACK_70 = createBlackWithAlpha(0.7);
  public static readonly BLACK_60 = createBlackWithAlpha(0.6);
  public static readonly BLACK_50 = createBlackWithAlpha(0.5);
  public static readonly BLACK_42 = createBlackWithAlpha(0.42);
  public static readonly BLACK_40 = createBlackWithAlpha(0.4);
  public static readonly BLACK_30 = createBlackWithAlpha(0.3);
  public static readonly BLACK_20 = createBlackWithAlpha(0.2);
  public static readonly BLACK_15 = createBlackWithAlpha(0.15);
  public static readonly BLACK_10 = createBlackWithAlpha(0.1);
  public static readonly BLACK_05 = createBlackWithAlpha(0.05);
  public static readonly BLACK_02 = createBlackWithAlpha(0.02);
  public static readonly RED_1 = 'rgba(255, 0, 0, 1)';
  public static readonly RED_2 = '#da1717';
  public static readonly DARK_RED = 'rgba(200, 0, 0, 1)';
  public static readonly LIGHT_GREY = '#C3C3C3';
  public static readonly MEDIUM_GREY = '#777777';
  public static readonly DARK_GREY = '#343A40';
  public static readonly JOBS_GREY = '#666666';

  public static readonly INFO = '#3498db';
  public static readonly INFO_BORDER = '#2979af';
  public static readonly SUCCESS = '#07bc0c';
  public static readonly WARNING = '#f1c40f';
  public static readonly WARNING_DARKER = '#e3ba12';
  public static readonly WARNING_BORDER = '#c09c0c';
  public static readonly ERROR = '#e74c3c';
  public static readonly ERROR_BORDER = '#b83c30';
  public static readonly PROCESSING = '#e74bc4';
  public static readonly RESTARTING = '#ff9d14';
  // Deliberately a deeper amber than WARNING (#f1c40f, Initializing) and
  // RESTARTING (#ff9d14): the warm end of this palette is crowded, and these are
  // rendered as small dots, so the third one has to differ in lightness rather
  // than just hue to stay tellable apart.
  public static readonly AWAITING_SOURCE = '#b8860b';

  public static readonly SELECTED_ITEM = '#f7f7f7';
}
